import { Divider } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

export const DescriptionBannerGroup = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <>
      <Wrapper>{children}</Wrapper>
      <Divider color='fillSecondary' spacing={'0px'} />
    </>
  );
};

const Wrapper = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
